import {Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ConfirmDialogService} from "../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {FormsModule} from "@angular/forms";
import {NotFoundComponent} from "../../../shared/not-found/not-found.component";

@Component({
  selector: 'app-switch-user-modal',
  standalone: true,
  imports: [
    FormsModule,
    NotFoundComponent
  ],
  templateUrl: './switch-user-modal.component.html',
  styleUrl: './switch-user-modal.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SwitchUserModalComponent implements OnInit {
  protected activeModal = inject(NgbActiveModal);
  private confirmDialogService = inject(ConfirmDialogService);
  isSearch: boolean = false;
  userList: any[]; // รอใส่ UserData

  ngOnInit(): void {
    this.isSearch = false;
  }

  search() {
    this.isSearch = true;
    this.userList = this.mockData();
  }

  select(user: any) {
    console.log('select User : ' + user);
  }

  close() {
    this.isSearch = false;
    this.activeModal.close(false);
  }

  mockData() {
    return [{
      userName: 'patay.k',
      orgName: 'สำนักงานหลักประกันสุขภาพแห่งชาติ(ส่วนกลาง)',
      name: 'Patay Kaewsapan',
      email: 'patay.k@tnhso.go.th',
      roleName: 'เจ้าหน้าที่ส่วนกลาง'
    }, {
      userName: 'patay.k2',
      orgName: 'สำนักงานหลักประกันสุขภาพแห่งชาติ(ส่วนกลาง)',
      name: 'Patay Kaewsapan ร่าง 2',
      email: 'patay.k2@tnhso.go.th',
      roleName: 'เจ้าหน้าที่ส่วนกลาง'
    }
    ];
  }

}
